// extracted by mini-css-extract-plugin
export var contentGrid = "_u-3";
export var divider = "_u-t";
export var emailInput = "_u-8";
export var emptyDescription = "_u-z";
export var emptyState = "_u-x";
export var emptyTitle = "_u-y";
export var fadeIn = "_u-10";
export var formCard = "_u-5";
export var formGroup = "_u-7";
export var helperText = "_u-9";
export var imagePlaceholder = "_u-n";
export var itemDetails = "_u-l";
export var itemImage = "_u-m";
export var itemInfo = "_u-p";
export var itemName = "_u-q";
export var itemPrice = "_u-s";
export var itemQuantity = "_u-r";
export var itemsList = "_u-j";
export var mainContent = "_u-4";
export var orderItem = "_u-k";
export var orderSummaryCard = "_u-i";
export var pageContainer = "_u-0";
export var pageHeader = "_u-1";
export var pageTitle = "_u-2";
export var paymentDescription = "_u-e";
export var paymentIcon = "_u-b";
export var paymentInfo = "_u-a";
export var paymentMethods = "_u-f";
export var paymentText = "_u-d";
export var placeholderText = "_u-o";
export var sectionTitle = "_u-6";
export var sidebarContent = "_u-h";
export var stripeIcon = "_u-c";
export var submitButton = "_u-g";
export var totalAmount = "_u-w";
export var totalLabel = "_u-v";
export var totalRow = "_u-u";